import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetEventMembershipsQueryVariables = Types.Exact<{
  filterEventTypes?: Types.InputMaybe<Array<Types.EventType> | Types.EventType>;
}>;

export type GetEventMembershipsQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'User';
    id: string;
    eventMemberships: Array<{
      __typename?: 'EventUser';
      id: string;
      status: Types.EventUserStatus;
      event?: {
        __typename?: 'Event';
        id: string;
        firebaseId: string;
        website: string;
        firebaseCreateAt?: { __typename?: 'Date'; milliseconds: number; timestamp: any; timezone: string } | null;
        info: {
          __typename?: 'EventInfo';
          id: string;
          eventType: Types.EventType;
          eventDisplayName?: string | null;
          eventMonogram?: string | null;
          ownerFirstName?: string | null;
          fianceeFirstName?: string | null;
          location?: string | null;
          timezone?: string | null;
          finalizedDate?: { __typename?: 'Date'; milliseconds: number; timestamp: any; timezone: string } | null;
          tentativeDate?: { __typename?: 'Date'; milliseconds: number; timestamp: any; timezone: string } | null;
        };
      } | null;
    }>;
  } | null;
};

export const GetEventMembershipsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventMemberships' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filterEventTypes' } },
          type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventType' } } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'eventMemberships' },
                  name: { kind: 'Name', value: 'activeEventUsers' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [{ kind: 'ObjectField', name: { kind: 'Name', value: 'types' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filterEventTypes' } } }],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'event' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firebaseId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firebaseCreateAt' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'info' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'eventMonogram' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'finalizedDate' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tentativeDate' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventMembershipsQuery__
 *
 * To run a query within a React component, call `useGetEventMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventMembershipsQuery({
 *   variables: {
 *      filterEventTypes: // value for 'filterEventTypes'
 *   },
 * });
 */
export function useGetEventMembershipsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventMembershipsQuery, GetEventMembershipsQueryVariables>) {
  return ApolloReactHooks.useQuery<GetEventMembershipsQuery, GetEventMembershipsQueryVariables>(GetEventMembershipsDocument, baseOptions);
}
export function useGetEventMembershipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventMembershipsQuery, GetEventMembershipsQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetEventMembershipsQuery, GetEventMembershipsQueryVariables>(GetEventMembershipsDocument, baseOptions);
}
export type GetEventMembershipsQueryHookResult = ReturnType<typeof useGetEventMembershipsQuery>;
export type GetEventMembershipsLazyQueryHookResult = ReturnType<typeof useGetEventMembershipsLazyQuery>;
export type GetEventMembershipsQueryResult = Apollo.QueryResult<GetEventMembershipsQuery, GetEventMembershipsQueryVariables>;
